<app-header (viewChange)="changeView($event)" [supplier]="supplier()"></app-header>

<div class="flex-row body-wrapper">
  <div class="flex-2">
    <app-dashboard (viewChange)="changeView($event)" [orders]="orders()" [(selectedOrder)]="selectedOrder"></app-dashboard>
  </div>
  <div class="flex-8">
    <div class="form-wrapper">
      @if (view === views.HOME) {
        <app-home (viewChange)="changeView($event)" [orders]="orders()" (selectedOrderChange)="selectedOrder = $event"></app-home>
      }
      @if (view === views.ORDER) {
        <app-existing-order [(selectedOrder)]="selectedOrder" [orders]="orders()"></app-existing-order>
      }
      @if (view === views.ACCOUNT) {
        <app-account [supplier]="supplier()"></app-account>
      }
    </div>
  </div>
</div>
